import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashWithdrawalCreateDTO, CashWithdrawalState } from "../../../types/cash/cashWithdrawal";

const initialFormState: CashWithdrawalCreateDTO = {

    sessionId: null,
    amount: 0,
    description: ""

};

const initialState: CashWithdrawalState = {

    form: initialFormState,

    loading: false,

    showModal: false

};

const cashWithdrawalSlice = createSlice({

    name: "cashWithdrawal",

    initialState,

    reducers: {

        /**
         * 🔄 Set formulario
         */
        setCashWithdrawalForm(state, action: PayloadAction<CashWithdrawalCreateDTO>) {

            state.form = action.payload;

        },

        /**
         * ✏️ Actualizar campo
         */
        updateCashWithdrawalField(
            state,
            action: PayloadAction<{ field: keyof CashWithdrawalCreateDTO; value: any }>
        ) {

            const { field, value } = action.payload;

            state.form = {
                ...state.form,
                [field]: value
            };

        },

        /**
         * 🧹 Limpiar formulario
         */
        clearCashWithdrawalForm(state) {

            state.form = initialFormState;

        },

        /**
         * ⏳ Loading
         */
        setLoading(state, action: PayloadAction<boolean>) {

            state.loading = action.payload;

        },

        /**
         * 📂 Modal
         */
        openModal(state) {

            state.showModal = true;

        },

        closeModal(state) {

            state.showModal = false;

        }

    }

});

export const {

    setCashWithdrawalForm,
    updateCashWithdrawalField,
    clearCashWithdrawalForm,

    setLoading,

    openModal,
    closeModal

} = cashWithdrawalSlice.actions;

export default cashWithdrawalSlice.reducer;